module.exports = __webpack_public_path__ + "static/testimonial-6-250648733be4ab6529640ffcc991c34b.png";